<template>
  <div class="input-control" @mousemove="mouseMovingActiveSuggestionItemLocked=false">
    <div class="box" :class="{focus: obtainedFocus}" @click="onBoxClicked" @mousedown="onBoxMouseDown">
      <div class="wrapper">
        <entity-item v-for="(item) in items" class="item" :key="item[itemValueProperty]" @mousedown.stop
                     @clickRemoveButton="onRemoveButtonClicked"
                     :transform-suggestions-data="transformSuggestionsData"
                     :item="item" :get-suggestion-item-h-t-m-l="getSuggestionItemHTML"
                     :pureLabel="staticOptions !== null"
                     ></entity-item>
        <textarea rows="1" spellcheck="false" autocomplete="off" autocapitalize="off"
                  ref="textarea" @blur="onTextareaBlurred" @focus="onTextareaFocused"
                  @keydown.esc="onTextareaEscaped" @input="onTextInput"
                  @keydown.enter.prevent="onTextareaKeydownEnter"
                  @keydown.up="moveSuggestedItemIndexFromKeydown(true)"
                  @keydown.down="moveSuggestedItemIndexFromKeydown(false)"
                  @keydown.delete="onTextareaKeydownDelete"
        ></textarea>
      </div>
    </div>
    <div class="dropdown-menu" :class="{show: showDropdownMenu}">
      <div class="wrapper" ref="dropdownScrollable">
        <div class="suggestion-items" v-if="showingSuggestedItems">
          <div class="suggestion-item" v-for="(item,index) in suggestionItems" :key="index"
               ref="suggestionItems"
               @mousedown.prevent="onSuggestionItemMousedown(item)"
               @mouseenter="!mouseMovingActiveSuggestionItemLocked && !isItemSelected(item) && setActiveSuggestedItemIndex(index)"
               :class="{active: index===activeSuggestedItemIndex, selected: isItemSelected(item)}"
          >
            <div v-html="getSuggestionItemHTML(item)"></div>
          </div>
        </div>
        <div class="results-indicator error-indicator" v-if="meetingLoadingError">There was something not
          right.
        </div>
        <div class="results-indicator loading-indicator" v-if="isLoading">Loading</div>
        <div class="results-indicator" v-if="showingEmptyIndicator">No suggestions found.</div>
      </div>
    </div>
  </div>
</template>

<script>
import EntityItem from "@/components/EntityItem";
import InputControlBase from "@/InputControls/InputControlBase";
import {getSuggestedEntities} from "@/apis";
import $ from 'jquery'
import {itemValueProperty} from "@/config";
import {transformArrayIntoString, getDataPointInSuggestionItem} from "@/utils";


const createLine = () => {
  const div = document.createElement('div');
  div.className = 'line';
  return div;
};

const createSpanWithInnerHTML = (h) => {
  const span = document.createElement('span');
  span.innerHTML = h;
  return span;
};

const getSuggestionItemHTML = (item, showId) => {
  let div;
  let temp;

  if (typeof showId === 'undefined') {
    showId = true;
  }

  if (item.objectType === 'person') {
    div = createLine();

    const nameEn = getDataPointInSuggestionItem(item, 'Gekko_fullname');
    const nameCh = getDataPointInSuggestionItem(item, 'Gekko_ch');
    const stockCodes = getDataPointInSuggestionItem(item, 'Stock_code');
    const gender = getDataPointInSuggestionItem(item, 'Gender');
    const gid = getDataPointInSuggestionItem(item, 'Gekko_id_person');

    temp = createLine();

    if (nameEn) {
      temp.appendChild(createSpanWithInnerHTML(nameEn));
      temp.appendChild(createSpanWithInnerHTML(' '));
    }
    if (nameCh) {
      temp.appendChild(createSpanWithInnerHTML(nameCh));
    }
    div.appendChild(temp);

    if (stockCodes) {
      temp = createLine();
      temp.appendChild(createSpanWithInnerHTML(stockCodes));
      div.appendChild(temp);
    }

    temp = createLine();
    if (gender) {
      temp.appendChild(createSpanWithInnerHTML(gender));
      temp.appendChild(createSpanWithInnerHTML(' '));
    }

    if (showId) {
      temp.appendChild(createSpanWithInnerHTML('(' + gid + ')'));
    }

    if (gender || showId) {
      div.appendChild(temp);
    }

  } else if (item.objectType === 'company') {
    div = createLine();

    const nameEn = getDataPointInSuggestionItem(item, 'Gekko_name_en');
    const nameCh = getDataPointInSuggestionItem(item, 'Gekko_name_ch');
    const listedCodes = getDataPointInSuggestionItem(item, 'Listed_code');
    const delistedCodes = getDataPointInSuggestionItem(item, 'Delisted_code');
    const placeInc = getDataPointInSuggestionItem(item, 'Place_inc');
    const gid = getDataPointInSuggestionItem(item, 'Gekko_id_company');
    const historicalNames = getDataPointInSuggestionItem(item, 'historical_names');
    const preListItem = getDataPointInSuggestionItem(item, 'pre_list_item', false);

    if (nameEn) {
      temp = createLine();
      temp.appendChild(createSpanWithInnerHTML(nameEn));
      div.appendChild(temp);
    }
    if (nameCh) {
      temp = createLine();
      temp.appendChild(createSpanWithInnerHTML(nameCh));
      div.appendChild(temp);
    }

    if (historicalNames) {
      temp = createLine();
      temp.appendChild(createSpanWithInnerHTML('Former: ' + historicalNames));
      div.appendChild(temp);
    }

    if (listedCodes || delistedCodes) {
      temp = createLine();
      if (listedCodes) {
        temp.appendChild(createSpanWithInnerHTML('Listed: ' + listedCodes));
      }
      if (delistedCodes) {
        temp.appendChild(createSpanWithInnerHTML('Listed: ' + delistedCodes));
      }
      div.appendChild(temp);
    }
    temp = createLine();
    if (placeInc) {
      temp.appendChild(createSpanWithInnerHTML(placeInc));
      temp.appendChild(createSpanWithInnerHTML(' '));
    }

    if (showId) {
      temp.appendChild(createSpanWithInnerHTML('(' + gid + ')'));
    }

    if (placeInc || showId) {
      div.appendChild(temp);
    }

    if (preListItem) {
      const {Listing_venue, Security_type, Special_issuer_type} = preListItem;
      const items = [Listing_venue, Security_type, Special_issuer_type].filter(v => v)
      if (items.length) {
        temp = createLine();
        temp.appendChild(createSpanWithInnerHTML(`<em class="text-gray">Pre List:</em> ${items.join('<span class="text-gray"> | </span>')}`));
        div.appendChild(temp);
      }
    }
  } else if (item.objectType === 'lr') {
    div = document.createElement('div');

    const category = getDataPointInSuggestionItem(item, 'cat');
    const ruleItem = getDataPointInSuggestionItem(item, 'i');
    div.appendChild(createSpanWithInnerHTML(category));
    div.appendChild(createSpanWithInnerHTML('<span class="text-gray"> — </span>'));
    div.appendChild(createSpanWithInnerHTML(ruleItem));
  } else {
    return null;
  }

  div.firstElementChild && (div.firstElementChild.style.fontSize = '1.05em');

  return div.innerHTML;
};

const transformSuggestionsData = (responseData) => {
  const data = [];

  responseData.forEach(item => {
    let entityId;
    let nameEn, nameCh;
    const _source = item['_source'];
    const objectType = item['object_type'];
    if (objectType === 'person') {
      entityId = _source['Gekko_id_person'];
      nameEn = _source['Gekko_fullname'];
      nameCh = _source['Gekko_ch'];
    } else if (objectType === 'company') {
      entityId = _source['Gekko_id_company'];
      nameEn = _source['Gekko_name_en'];
      nameCh = _source['Gekko_name_ch'];
    }

    entityId = transformArrayIntoString(entityId);
    nameEn = transformArrayIntoString(nameEn);
    nameCh = transformArrayIntoString(nameCh);

    data.push({
      entityId: entityId,
      _source: item,
      objectType,
      nameEn,
      nameCh,
    })
  });

  return data;
};

export default {
  name: "AutocompleteBox",
  components: {EntityItem},
  mixins: [InputControlBase],
  props: {
    spellcheck: {
      default: 'true'
    },
    entityType: {
      default: null
    },
    staticOptions: {
      default: null
    },
    staticOptionsFilter: {
      default: null
    }
  },
  created() {
    if (typeof this.value === "undefined" || this.value === null) {
      this.value = [];
    }

    if (Array.isArray(this.value)) {
      this.items = this.value.map(item => {
        const i = {};
        i[itemValueProperty] = item;
        return i;
      })
    }
  },
  mounted() {
    if (!Array.isArray(this.value)) {
      if (typeof this.value === 'string') {
        this.setTextareaText(this.value);
        this.value = [];
      } else {
        throw new Error(('the value cannot be recognized by AutocompleteBox: ' + this.value))
      }
    }
  },
  methods: {
    setTextareaText(text) {
      this.$refs.textarea.value = text;
    },
    getSuggestionItemHTML: getSuggestionItemHTML,
    isItemSelected(item) {
      return this.value.indexOf(item[itemValueProperty]) !== -1;
    },
    setObtainedFocus(b) {
      if (this.obtainedFocus === b) {
        return
      }
      this.obtainedFocus = b;
    },
    onBoxClicked() {
      this.focusTextarea();
    },
    onRemoveButtonClicked(item) {
      this.items = this.items.filter(value => (value !== item));
      this.onItemsChanged();
    },
    onBoxMouseDown(event) {
      if (this.obtainedFocus && event.target !== this.$refs.textarea) {
        event.preventDefault()
      }
    },
    onTextareaBlurred() {
      this.setObtainedFocus(false);
      this.hideDropdownMenu();
      this.$refs.textarea.value = '';
    },
    onTextareaFocused() {
      this.setObtainedFocus(true);
      this.tryAutocomplete();
    },
    blurTextarea() {
      this.$refs.textarea.blur();
    },
    focusTextarea() {
      this.$refs.textarea.focus();
    },
    onTextInput() {
      this.tryAutocomplete();
    },
    setDropdownMenuData(showDropdownMenu, suggestionItems, currentlyLoadingKeywords, isLoading, meetingLoadingError, showingSuggestedItems, showingEmptyIndicator) {
      this.showDropdownMenu = showDropdownMenu;
      this.suggestionItems = suggestionItems;
      this.currentlyLoadingKeywords = currentlyLoadingKeywords;
      this.isLoading = isLoading;
      this.meetingLoadingError = meetingLoadingError;
      this.showingSuggestedItems = showingSuggestedItems;
      this.showingEmptyIndicator = showingEmptyIndicator;

      let i = -1;

      if (showingSuggestedItems) {
        for (let j = 0; j < suggestionItems.length; j++) {
          if (!this.isItemSelected(suggestionItems[j])) {
            i = j;
            break;
          }
        }
      }

      this.setActiveSuggestedItemIndex(i);
    },
    transformSuggestionsData: transformSuggestionsData,
    tryAutocomplete() {
      const elem = this.$refs.textarea;

      if (!document.hasFocus()) {
        return;
      }

      const value = elem.value.trim();

      if (value === this.currentlyLoadingKeywords) {
        return;
      }

      if (this.staticOptions) {
        // use static options instead of loading the dynamic
        let data = this.staticOptions.map(o => {
          return {
            entityId: o.objectId,
            objectType: o.objectType,
            _source: {
              _source: o.objectDetail
            }
          }
        });
        if (this.staticOptionsFilter && value) {
          data = data.filter(o => {
            const result = this.staticOptionsFilter(value, o._source._source);
            if (result.found) {
              o._source.highlight = result.highlight;
              return true;
            } else {
              return false;
            }
          })
        }
        
        this.setDropdownMenuData(true, data, null, false, false, data.length > 0, data.length === 0);
        return;
      }

      if (!value) {
        this.hideDropdownMenu();
        return;
      }

      this.setDropdownMenuData(true, null, value, true, false, null, false);

      getSuggestedEntities(value, 20, this.entityType || undefined).then(r => {
        if (this.currentlyLoadingKeywords !== value) {
          return;
        }
        const responseData = r.data;

        const data = this.transformSuggestionsData(responseData);

        this.setDropdownMenuData(true, data, null, false, false, data.length > 0, data.length === 0)
      }).catch((err) => {
        if (elem.value.trim() !== value) {
          return;
        }
        this.setDropdownMenuData(true, null, null, false, true, false, false);
        this.handleServerSideError(err).catch(() => {

        })
      })
    },
    onTextareaEscaped() {
      if (this.showDropdownMenu) {
        this.hideDropdownMenu();
        return;
      }
      this.blurTextarea();
    },
    selectSuggestionItem(item) {
      this.items.push(item);
      this.onItemsChanged();
    },
    onSuggestionItemMousedown(item) {
      if (this.isItemSelected(item)) {
        return;
      }
      this.selectSuggestionItem(item);
      this.$refs.textarea.value = '';
      this.focusTextarea();
      this.moveSuggestedItemIndexFromKeydown(false);
      if (!this.staticOptions) {
        this.hideDropdownMenu();
      }
    },
    hideDropdownMenu() {
      this.setDropdownMenuData(false, null, null, false, false, false, false);
    },
    onTextareaKeydownEnter() {
      if (this.activeSuggestedItemIndex >= 0) {
        this.onSuggestionItemMousedown(this.suggestionItems[this.activeSuggestedItemIndex]);
      }
    },
    onTextareaKeydownDelete(event) {
      if (!event.currentTarget.value && this.items.length) {
        this.onRemoveButtonClicked(this.items[this.items.length - 1]);
      }
    },
    setActiveSuggestedItemIndex(newIndex) {
      if (newIndex !== this.activeSuggestedItemIndex) {
        this.activeSuggestedItemIndex = newIndex;
      }
    },
    moveSuggestedItemIndexFromKeydown(up) {
      if (!this.showingSuggestedItems) {
        return;
      }

      let nextIndex = -1;

      if (up) {
        for (let j = this.activeSuggestedItemIndex - 1; j >= 0; j--) {
          if (!this.isItemSelected(this.suggestionItems[j])) {
            nextIndex = j;
            break;
          }
        }
      } else {
        for (let j = this.activeSuggestedItemIndex + 1; j < this.suggestionItems.length; j++) {
          if (!this.isItemSelected(this.suggestionItems[j])) {
            nextIndex = j;
            break;
          }
        }
      }

      if (nextIndex < 0 || nextIndex >= this.suggestionItems.length) {
        return;
      }

      this.mouseMovingActiveSuggestionItemLocked = true;

      this.setActiveSuggestedItemIndex(nextIndex);

      const dropdownScrollable = this.$refs.dropdownScrollable;
      const targetElem = this.$refs.suggestionItems[nextIndex];

      const dropdownScrollTop = dropdownScrollable.scrollTop;
      const dropdownClientHeight = dropdownScrollable.clientHeight;
      const targetElemOffsetTop = $(targetElem).position().top;
      const targetElemClientHeight = targetElem.getBoundingClientRect().height;

      let diff = targetElemOffsetTop + targetElemClientHeight - dropdownClientHeight;

      if (diff > 0) {
        dropdownScrollable.scrollTop = dropdownScrollTop + diff;
      } else if (targetElemOffsetTop < 0) {
        dropdownScrollable.scrollTop = dropdownScrollTop + targetElemOffsetTop;
      }
    },
    onItemsChanged() {
      this.value = this.items.map(item => (item[itemValueProperty]));
    },
    setInputValue(value) {
      if (typeof value === 'string') {
        this.setTextareaText(value);
      } else if (Array.isArray(value)) {
        this.value = value;
        this.items = this.value.map(item => {
          const i = {};
          i[itemValueProperty] = item;
          return i;
        });
      } else if (typeof this.value === "undefined" || this.value === null) {
        this.value = [];
        this.items = [];
      } else {
        throw new Error(('the value cannot be recognized by AutocompleteBox: ' + value))
      }

      if (document.activeElement === this.$refs.textarea) {
        this.tryAutocomplete();
      }
    },
    focus() {
      this.$refs.textarea.focus();
    }
  },
  data() {
    return {
      itemValueProperty,
      items: [],
      obtainedFocus: false,

      showDropdownMenu: false,
      suggestionItems: null,
      currentlyLoadingKeywords: null,
      isLoading: false,
      meetingLoadingError: false,
      showingSuggestedItems: false,
      showingEmptyIndicator: false,
      activeSuggestedItemIndex: -1,
      mouseMovingActiveSuggestionItemLocked: false,
    }
  }
}

export {
  transformSuggestionsData,
  getSuggestionItemHTML,
}
</script>

<style scoped lang="scss">
@import "../assets/variables";
@import "input-controls";

.input-control {
  position: relative;
}

.box {
  border: 1px solid lightgray;
  border-radius: 4px;
  background-color: white;
  cursor: text;

  &.focus {
    box-shadow: 0 0 0 3px rgba($primary-blue, 0.6);
    border: 1px solid rgba(lightgray, 0.5);
    outline: none;
  }

  .wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    max-width: 100%;
    min-width: 0;
    min-height: 22px;

    textarea {
      border: none;
      background-color: transparent;
      resize: none;
      flex: 1 1;
      min-width: 0;

      &:focus {
        box-shadow: none;
      }
    }
  }
}

.dropdown-menu {
  position: absolute;
  top: calc(100% - 1px);
  left: 0;
  width: 100%;
  z-index: 9999;
  padding-left: 1px;
  padding-right: 1px;
  display: none;
  font-size: 14px;

  &.show {
    visibility: visible;
    display: block;
  }

  .wrapper {
    background-color: white;
    box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.302), 0 2px 6px 2px rgba(60, 64, 67, 0.149);
    border-radius: 2px;
    max-height: 420px;
    overflow: auto;

    .suggestion-items {
      padding: 0.5rem 0;

      .suggestion-item {
        padding: 0.5rem 1rem;
        line-height: 1.5;

        &.active {
          background-color: rgba(black, 0.08);
        }

        &.selected {
          position: relative;
          cursor: not-allowed;
          opacity: 0.5;

          &:after {
            content: '✓';
            position: absolute;
            bottom: 0rem;
            right: 0.25rem;
            line-height: 1;
            font-size: 12px;
          }
        }

        &:not(:last-child) {
          border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        }
      }
    }

    .results-indicator {
      padding: 1rem 1rem;
    }
  }
}
</style>
<style lang="scss">
@import "../assets/variables";

.suggestion-item {
  .highlight {
    color: $primary-orange;
  }

  .line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
}
</style>
